export enum MappingsActionTypes {
    LOAD_SERVER_MAPPINGS         = '@@mappings/LOAD_SERVER_MAPPINGS',
    LOAD_SERVER_MAPPINGS_REQUEST = '@@mappings/LOAD_SERVER_MAPPINGS_REQUEST',
    LOAD_SERVER_MAPPINGS_SUCCESS = '@@mappings/LOAD_SERVER_MAPPINGS_SUCCESS',
    FETCH_MAPPING_REQUEST        = '@@mappings/FETCH_MAPPING_REQUEST',
    FETCH_MAPPING_SUCCESS        = '@@mappings/FETCH_MAPPING_SUCCESS',
    INIT_MAPPING_WORKING_COPY    = '@@mappings/INIT_MAPPING_WORKING_COPY',
    SYNC_MAPPING_WORKING_COPY    = '@@mappings/SYNC_MAPPING_WORKING_COPY',
    UPDATE_MAPPING_REQUEST       = '@@mappings/UPDATE_MAPPING_REQUEST',
    UPDATE_MAPPING_SUCCESS       = '@@mappings/UPDATE_MAPPING_SUCCESS',
    DELETE_MAPPING_REQUEST       = '@@mappings/DELETE_MAPPING_REQUEST',
    DELETE_MAPPING_SUCCESS       = '@@mappings/DELETE_MAPPING_SUCCESS',
}


// WEBPACK FOOTER //
// ./src/modules/mappings/store/types.ts